export default __webpack_public_path__ + "static/media/asset_2.20fb0eca.png";